import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router";

const useSubNavigation = () => {
  const subNavRef = useRef();

  const [selectedMenu, setSelectedMenu] = useState(null);
  const selectMenu = (id) => {
    setSelectedMenu((current) => (current === id ? null : id));
  };

  const renderSubNav = (id) =>
    selectedMenu === id
      ? (element) => createPortal(element, subNavRef.current)
      : /**
         * the below will only render sub menus on the server for seo purposes
         * on the client on rehydration the sub menus are removed. we had to do this
         * because SubNavigation component has a side effect of disabling the page scroll
         * so if rendered on the client (even with display none) it will disable the page scroll
         */
        (element) =>
          typeof window === "undefined" ? (
            <div style={{ display: "none" }}>{element}</div>
          ) : null;

  const location = useLocation();
  useEffect(() => {
    selectMenu(null);
  }, [location.key]);

  return [subNavRef, selectMenu, renderSubNav];
};

export default useSubNavigation;
